import { render, staticRenderFns } from "./Fqa.vue?vue&type=template&id=c19c39b4&scoped=true"
import script from "./Fqa.vue?vue&type=script&lang=js"
export * from "./Fqa.vue?vue&type=script&lang=js"
import style0 from "./Fqa.vue?vue&type=style&index=0&id=c19c39b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19c39b4",
  null
  
)

export default component.exports